module.exports = __webpack_public_path__ + "static/media/logo-gazeta-min-white.9018c4d8.png";